import { Link } from "react-router-dom";

import { Icon } from "../../../components/icons";
import { PRIMER_TORNEO_TEXTO, TRUST_ITEMS } from "../content";
import { MoneyFlow } from "../mockups/MoneyFlow";
import { PriceCalculator } from "./PriceCalculator";
import { PLATFORM_FEE_PER_PLAYER } from "./priceCalculation";
import "./Pricing.css";

const FIRST_TOURNAMENT_POINTS = [
  "Cobras en línea con Mercado Pago desde el primer jugador.",
  "Tus jugadores se inscriben y pagan igual que en cualquier torneo.",
  "Después decides si sigues.",
];

const PER_PLAYER_POINTS = [
  "Sin mensualidad.",
  "Se descuenta sola de cada inscripción pagada en línea; el resto llega a tu cuenta.",
  "Un solo cargo por inscripción, aunque el jugador elija varias categorías en el mismo registro.",
  "Si tu torneo no cobra inscripción, no pagas comisión.",
  "Ves cada comisión en tu dashboard financiero.",
];

/** Precio (#precio), §8 de la especificación: las dos tarjetas (primer torneo
 * gratis y $99 MXN por jugador inscrito, por torneo), «¿Quién paga los $99?»
 * con el flujo del dinero, la calculadora y la fila «Claro desde el
 * principio». */
export function Pricing() {
  const fee = `$${PLATFORM_FEE_PER_PLAYER}`;
  return (
    <section id="precio" className="t123-section t123-precio" aria-labelledby="t123-precio-title">
      <div className="t123-shell">
        <div className="t123-heading-center">
          <span className="t123-kicker">Precio</span>
          <h2 id="t123-precio-title" className="t123-h2">
            Un precio simple: pagas solo por jugador inscrito
          </h2>
          <p className="t123-lead">Sin mensualidad. Tu primer torneo va sin comisión de Torneos123.</p>
        </div>

        <div className="t123-precio__cards">
          <article
            className="t123-price-card is-featured t123-precio__card t123-precio__card--first"
            data-ribbon="Para empezar"
            aria-labelledby="t123-precio-first"
          >
            <h3 id="t123-precio-first" className="t123-precio__title">
              {PRIMER_TORNEO_TEXTO}
            </h3>
            <p className="t123-precio__amount">
              <span className="t123-precio__num">$0</span>
            </p>
            <p className="t123-precio__per">de comisión de Torneos123 en tu primer torneo</p>
            <ul className="t123-checklist t123-precio__list">
              {FIRST_TOURNAMENT_POINTS.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <a className="t123-btn t123-btn--primary t123-precio__cta" href="#demo">
              Quiero mi primer torneo gratis
            </a>
            <p className="t123-precio__fine">Mercado Pago cobra aparte su propia comisión por cada pago en línea.</p>
          </article>

          <article className="t123-price-card t123-precio__card" aria-labelledby="t123-precio-per-player">
            <h3 id="t123-precio-per-player" className="t123-precio__label">
              Desde tu segundo torneo
            </h3>
            <p className="t123-precio__amount">
              <span className="t123-precio__num">{fee}</span> <span className="t123-precio__cur">MXN</span>
            </p>
            <p className="t123-precio__per">por jugador inscrito, por torneo</p>
            <ul className="t123-checklist t123-precio__list">
              {PER_PLAYER_POINTS.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <a className="t123-btn t123-btn--outline t123-precio__cta" href="#demo">
              Pedir demo
            </a>
          </article>
        </div>

        <div className="t123-precio__split">
          <div className="t123-pricing-note t123-precio__who">
            <h3>¿Quién paga los {fee}?</h3>
            <p>
              Tú fijas el costo de inscripción y el jugador paga ese monto. Cuando paga en línea, Mercado Pago separa en
              automático {fee} para Torneos123 y deposita el resto en tu cuenta, menos su propia comisión.
            </p>
            <p className="t123-precio__tip">
              <span className="t123-precio__tip-icon" aria-hidden="true">
                <Icon name="wallet" />
              </span>
              <span>Si prefieres que no salga de tu bolsa, súmalo a tu costo de inscripción.</span>
            </p>
            <div className="t123-precio__flow">
              <MoneyFlow compact />
            </div>
          </div>

          <PriceCalculator />
        </div>

        <div className="t123-precio__trust">
          <h3 className="t123-precio__trust-title">Claro desde el principio</h3>
          <ul className="t123-precio__trust-list">
            {TRUST_ITEMS.map((item) => (
              <li key={item.title}>
                <span className="t123-tile-icon" aria-hidden="true">
                  <Icon name={item.icon} />
                </span>
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.copy}</p>
                  {item.icon === "book" ? (
                    <Link className="t123-link-arrow t123-precio__guide" to="/guia">
                      Ver la guía
                    </Link>
                  ) : null}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
